import React from "react";
import { Dropdown } from "antd";
import { Button } from "../components";

const ButtonDropdown = ({ items, overlay, ...buttonProps }) => {
  return (
    <Dropdown
      menu={{
        items: items || [],
      }}
      placement="bottomLeft"
      trigger={["click"]}
    >
      <Button {...buttonProps} />
    </Dropdown>
  );
};

export default ButtonDropdown;
